<!-- Oscurecido del contenido: SIEMPRE presente para poder fundirse (opacity) en
     sincronía con el deslizamiento del sidebar (misma duración y curva, 300ms
     ease-in-out); antes usaba @if y aparecía de golpe. Cerrado queda invisible y
     sin capturar clics (pointer-events-none). -->
<div
  class="fixed inset-0 z-40 bg-gray-900/50 lg:hidden transition-opacity duration-300 ease-in-out"
  [ngClass]="(isMobileOpen$ | async) ? 'opacity-100' : 'opacity-0 pointer-events-none'"
  (click)="closeSidebar()"
></div>
